import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { AgentService } from '../services/agent.service';
// import { SearchResponseIO } from 'src/app/models/search-responseIO';

@Component({
  selector: 'sym-agent-checker-search',
  templateUrl: './agent-checker-search.component.html',
  styleUrls: ['./agent-checker-search.component.scss'],
})
export class AgentCheckerSearchComponent extends BaseSearchComponent<AgentService> implements OnInit {
  responseData;
  isAdvanceSearchDisplayed: boolean;
  //
  checkerGraphSearchList: boolean;
  checkerDefaultSearchList: boolean;

  constructor(
    public service: AgentService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, router, headerService);
    // this.isSearchFilteredByCriteria = true;
    this.checkerGraphSearchList = false;
    this.checkerDefaultSearchList = false;
  }

  ngOnInit() {
    super.ngOnInit();
    this.service.forAuditSearchList = false;
    this.settingService.removeSessionStorage('AuditChanges');
    this.searchApplicationList();
  }

  searchApplicationList() {
    this.isAdvanceSearchDisplayed = true;
    if (
      this.settingService.getSessionStorageValue('ApplicationStatus') != null &&
      this.settingService.getSessionStorageValue('ApplicationStatus') != undefined
    ) {
      this.checkerGraphSearchList = true;
      this.checkerDefaultSearchList = false;
    } else {
      this.onSearchList();
    }
  }

  onSearchList() {
    this.service.find(false, undefined).subscribe(
      (criteriaData) => {
        //criteriaData['data']['searchCriteriaData']['PortalAgentDO.applicationStatusCd'] = 'Submitted';
        this.settingService.setSessionStorageValue(
          'CheckerApplicationStatus',
          JSON.stringify(criteriaData['data']['searchCriteriaData'])
        );
        if (this.settingService.getSessionStorageValue('CheckerApplicationStatus')) {
          this.checkerGraphSearchList = false;
          this.checkerDefaultSearchList = true;
        }
      },
      (error) => {
        console.log('Criteria load failed', error);
      }
    );
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'Home',
        link: '/home',
      },
      {
        id: 'Search',
      },
    ];
  }

  protected getMoreOptionList(): any[] {
    return [
      {
        id: 'Review',
        link: '/review/:id',
      },
    ];
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    header.title = 'Search - Agent';
    return header;
  }

  // find(executeSearch?: boolean, searchCriteriaData?: any) {
  //   this.service.getSearchList(this.searchName, executeSearch, searchCriteriaData).subscribe(
  //     (searchList) => {
  //       let list = JSON.parse(JSON.stringify(searchList));
  //       this.searchResponseIO = new SearchResponseIO();
  //       this.searchResponseIO = list;
  //       sessionStorage.removeItem('ApplicationStatus');
  //       this.isSearchFilteredByCriteria = false;
  //     },
  //     (error) => {
  //       console.log('Get search list failed.');
  //       console.log('Error:', error);
  //     }
  //   );
  // }

  Review_click(optionDetails: { button_id; link; ref_id }) {
    let link: string;
    link = optionDetails.link.toString().replace(':id', optionDetails.ref_id);
    this.router.navigate([link]);
  }

  Delete_click(optionDetails: { button_id; link; ref_id }) {
    // console.log(optionDetails.ref_id, ' Delete');
    this.service.deleteAgent(optionDetails.ref_id).subscribe(
      (deleteResponse) => {
        if (deleteResponse['success'] == true) {
          alert(deleteResponse['message']);
          this.reloadCurrentRoute();
        } else {
          alert(deleteResponse['message']);
        }
      },
      (error) => {
        console.log('Delete Agent load failed.');
        console.log('Error:', error);
      }
    );
  }

  Delete_All_click(optionDetails: { button_id; link; ref_id }) {
    this.service.deleteAgents(optionDetails.ref_id).subscribe(
      (deleteResponse) => {
        if (deleteResponse['success'] == true) {
          alert(deleteResponse['message']);
          this.reloadCurrentRoute();
        } else {
          alert(deleteResponse['message']);
        }
      },
      (error) => {
        console.log('Delete Lead load failed.');
        console.log('Error:', error);
      }
    );
  }
}
